import type { ApiSuccess } from '@mds/shared/types/api';
import type {
  AdminEventFeedbackResponseList,
  EventFeedbackForm,
  ReplaceEventFeedbackFormRequest,
} from '@mds/shared/types/event-feedback';

import { api } from '@/lib/api';

/** The post-event feedback form and its anonymous results — see `backend/docs/event-feedback.md`. */

/** An event with no form yet reads as version 0, disabled and empty. */
export const getForm = (eventId: string): Promise<EventFeedbackForm> =>
  api
    .get<ApiSuccess<EventFeedbackForm>>(`admin/events/${eventId}/feedback-form`)
    .then((r) => r.data);

/**
 * Replaces the whole form in one go. `expectedVersion` is the version this copy
 * was loaded at; a stale one is refused rather than overwriting someone else.
 */
export const replaceForm = (
  eventId: string,
  body: ReplaceEventFeedbackFormRequest,
): Promise<EventFeedbackForm> =>
  api
    .put<ApiSuccess<EventFeedbackForm>>(`admin/events/${eventId}/feedback-form`, body)
    .then((r) => r.data);

/** A type alias, so it carries the index signature the client's `query` needs. */
export type ResponseQuery = {
  page?: number;
  limit?: number;
  direction?: 'asc' | 'desc';
};

/** Anonymous: no attendee, ticket or contact detail comes back. */
export const listResponses = (eventId: string, query: ResponseQuery = {}) =>
  api.get<AdminEventFeedbackResponseList>(`admin/events/${eventId}/feedback-responses`, { query });
